<script setup lang="ts">
  import { DocumentSendReportPage } from '@/features/DocumentSendControl';
</script>

<template>
  <div data-testid="document-management-send-list-page">
    <DocumentSendReportPage />
  </div>
</template>
